import { createCompositionContributorsQuery } from "./composition"
import { createPerformanceContributorsQuery } from "./performance"
import type { ContributorsQueryOptions } from "./contributors-query-types"

export interface DrilldownBaseGathererOptions {
  endDate: string
  startDate: string
  classifications?: unknown[]
  excludePerformance?: boolean
  /**
   * Appended to every gatherer prefix so that comparison gatherers store data
   * under distinct keys (e.g. "performance-comparison") without colliding with
   * the original-instrument gatherers (e.g. "performance").
   * Defaults to "" (original instrument — no suffix).
   */
  instrumentSuffix?: string
  [key: string]: unknown
}

export function createDrilldownBaseGatherers({
  endDate,
  startDate,
  classifications,
  excludePerformance = false,
  instrumentSuffix = "",
  ...coreOptions
}: DrilldownBaseGathererOptions) {
  const classificationList = classifications ?? []
  const sharedOptions: Omit<ContributorsQueryOptions, "prefix"> = {
    ...coreOptions,
    to: endDate,
    classifications: classificationList,
  }
  return [
    ...createCompositionContributorsQuery({
      ...sharedOptions,
      prefix: `composition${instrumentSuffix}`,
    }),
    ...createCompositionContributorsQuery({
      ...sharedOptions,
      prefix: `marketValue${instrumentSuffix}`,
      scaleFormat: "DEFAULT",
    }),
    ...(excludePerformance
      ? []
      : [
        createPerformanceContributorsQuery({
          ...coreOptions,
          prefix: `performance${instrumentSuffix}`,
          from: startDate,
          to: endDate,
        }),
      ]),
  ]
}
